var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeapLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 38,
    viewBox: "0 0 162 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 162,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 0.5H0V37.5H162V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_68)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19109 7.41077L1.56939 11.1986V35.8166H2.84449L0.790161 37.5002H5.2616L13.6786 30.6019H9.20926L11.2614 28.9183H11.1756V7.41077H6.19109Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6369 35.8167L27.9598 33.0951V28.9185H15.7305L7.31354 35.8167H24.6369Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.61871V10.4083L4.62171 6.61871H0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6871 36.008V29.2294H46.8397V24.6693H63.6801V18.3851H52.0968L59.6551 12.1905H67.6792V5.41193L65.4339 7.2504H37.2635V31.1172L43.2291 36.0063H65.685L65.6871 36.008ZM46.8397 14.029H56.9182L51.6052 18.3833H46.8397V14.029Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.901 24.0258H108.521L99.8635 7.24023H90.6054L78.8975 29.9371V35.8483H85.8933L91.2982 24.6891H91.2474L95.1603 16.6138L95.1862 16.6666L95.212 16.6138L98.7562 24.0258H104.136L107.351 30.7499H101.971L104.41 35.8483H112.029V30.8273L111.988 30.7499H117.37L113.901 24.0258Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_40_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 162,
    height: 38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162 0.5H0V37.5H162V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_40_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.897 21.5674C156.35 20.7933 156.646 19.9348 156.825 19.0111H160.003C160.117 18.4164 160.19 17.8007 160.19 17.1445V17.0636C160.19 16.5146 160.133 15.9921 160.051 15.4819H156.871C156.717 14.5372 156.436 13.6523 155.996 12.8448C155.319 11.6009 154.353 10.5523 153.1 9.6991C151.844 8.84758 150.327 8.19838 148.545 7.75154C146.763 7.30467 144.781 7.08124 142.603 7.08124H133.613L127.748 11.8876V15.4819H130.927V19.0111H127.748V35.487H131.412L137.354 30.6173V27.3713H142.107C144.252 27.3713 146.241 27.155 148.072 26.7221C149.903 26.2894 151.481 25.6402 152.801 24.7746C154.121 23.909 155.155 22.8411 155.897 21.5691M147.046 19.0129C146.801 19.4703 146.437 19.8679 145.946 20.2057C144.971 20.8724 143.627 21.205 141.909 21.205H137.354V19.0129H140.533V15.4837H137.354V13.6575H141.86C143.61 13.6575 144.971 13.976 145.946 14.6163C146.314 14.8591 146.591 15.1565 146.821 15.4837H150C150.376 16.0186 150.586 16.6518 150.586 17.4101V17.4911C150.586 18.0558 150.466 18.5642 150.226 19.0129H147.046Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapLogo);
export default __webpack_public_path__ + "static/media/leap-logo.282c421a5be4a3b988ebf2533a4c4b4d.svg";
export { ForwardRef as ReactComponent };